import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link } from 'react-router-dom';
import Loader from './Loader';  
import ReactPaginate from 'react-paginate'; 
import "./Charger.css"
import request from '../../Apis/request';
import { fetchStatusList } from '../../Apis/StatusListing';
import { useNavigate } from 'react-router-dom';

const Connectors = () => {
  document.title = "Connectors";


  const [loading, setLoading] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [chargingList, setChargingList] = useState([]);
  const [selectedchargerType, setselectedchargerType] = useState([]);
  const [filteredConnectorsData, setFilteredConnectorsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1); 
  const [pageCount, setPageCount] = useState(0); 
  const [userStatuses, setUserStatuses] = useState({});
  const [statusListing, setStatusListing] = useState([]);
  const [Limit, setLimit] = useState(20);
  const [TotalCount, setTotalCount] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");


  const handleStatus = (e) => {
    setSelectedStatus(e.target.value);
  }
  let navigate = useNavigate();

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/connectors`);
    }
  


  
  

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };

  const handlechargerType = (e) => {
    setselectedchargerType(e.target.value);
}

  const handleSearchSubmit = (e) => {
    e.preventDefault();  // Prevent default form submission
    setPage(1);  // Reset to the first page
    fetchConnectors(1, searchTerm);  // Trigger the API call with search term on form submit
  };

  const fetchConnectors = async (currentPage, searchTerm = '') => {
    setLoading(true);
    
    const apiEndpoint = `${BaseURL}/chargers/charger-connectors?page=${page}&connector_status=${selectedStatus}&searchText=${searchTerm}&limit=${Limit}`;
  
    try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      
      setChargerData(response.data.data || []);
      setFilteredConnectorsData(response.data.data|| []); 
  
      setPageCount(Math.ceil(response.data?.totalCount / response?.data?.limit || 0));
      setLimit(response?.data?.limit);
      setTotalCount(response.data?.totalCount);
    } catch (error) {
      console.error("Error fetching ChargerData:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConnectors(page);  // Fetch all chargers for the current page
  }, [page]);

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setPage(selectedPage);
  };
  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // Update local state
    setUserStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${BaseURL}/chargers/changestatus/${userId}`;
  
    // Create JSON payload
    const statusData = { status };
  
    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        console.log("Failed to update status", response.data);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const fetchStatusListing = async () => {
    setLoading(true);
    try {
      const statusData = await fetchStatusList();
      setStatusListing(statusData);
    } catch (error) {
      console.error("Error fetching classes:", error);
    } finally {
      setLoading(false);
    }
  };
// setStatusListing(res.data);
  useEffect(() => {
    fetchStatusListing();
  }, []);
  
  useEffect(() => {
    const ChargingTypesData = async () => {
      setLoading(true);
      const apiEndpoint = `${BaseURL}/master/station_charger-0`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("ocpps response", response);
        setChargingList(response?.data?.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };

    ChargingTypesData();
  }, []);

  
  const buttonStyle = {
    padding: '5px 10px',
    borderRadius: '5px',
    width: '110px', // Set a fixed width to ensure uniform size
    height: '40px', // Set a fixed height
    border: 'none',
    textAlign: 'center'
  };

  const getStatusColors = (status) => {
    switch (status) {
      case 'NotAvailable':
      case 'Faulted':
        return '#dc3545'; // Red
      case 'Available':
      case 'Preparing':
      case 'Active':
        return '#28a745'; // Green
      case 'Charging':
        return '#ff9800'; // Orange
      case 'Finishing':
        return '#6f42c1'; // Purple
      case 'Deleted':
        return '#6c757d'; // Grey
      case 'InActive':
        return '#17a2b8'; // Light Blue
      default:
        return '#6f42c1'; // Default Grey for unhandled statuses
    }
  };
  
console.log("charginglist", chargingList);
console.log("pageCount", pageCount);
console.log("limit", Limit);
console.log("chargerData", ChargerData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>

            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  {/* Chargers heading and Total Chargers button */}
  <div className="d-flex align-items-center">
    <h4 style={{ marginRight: "10px" }}>Connectors({TotalCount ? TotalCount : "Loading..."})</h4>  {/* Add margin to separate */}
   </div>

  {/* Add Chargers button */}
  {/* <Link
    className="form-control d-inline-block"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      maxWidth: "150px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
    }}
    to="/chargers/add"
  >
    <i className="fa fa-plus"></i> Add Chargers
  </Link> */}
</div>

              <hr style={{ marginTop: "5px" }} />

              <div className="row" style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "nowrap" }}>
  <div className="col-sm-12">
  <form className="form-horizontal" role="form" method="post" style={{ marginTop: "-5px" }} onSubmit={handleSearchSubmit}>
  <div className="row px-3" style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "nowrap" }}>

    {/* Search input field */}
    <div className= "col-md-2">
      <div className="form-group">
        <input
          type="text"
          placeholder="Find Data Here."
          onChange={handleSearchChange}
          value={searchTerm}
          className="form-control"
          style={{ height: "38px" }} // Ensure height consistency
        />
      </div>
    </div>

    {/* Select dropdown field */}
    <div className= "col-md-2">
      <div className="form-group">
        <select
          className="form-select"
          style={{
            border: "1px solid black",
            borderRadius: "34px",
            height: "38px", // Ensure the height matches the input and button
          }}
          onChange={handleStatus} // Handle the change as needed
        >
          <option value="">Select Connector Status</option>
          {statusListing.map((status, index) => {
            const statusKey = Object.keys(status)[0]; // Get the key, e.g., "Active"
            const statusValue = status[statusKey]; // Get the value, e.g., "Active"
            return (
              <option key={index} value={statusValue}>
                {statusValue}
              </option>
            );
          })}
        </select>
      </div>
    </div>

    {/* Search button */}
    <div className= "col-md-2">
      <div className="form-group">
        <button 
          type="submit" 
          className="btn btn-primary" 
          style={{ height: "38px", lineHeight: "20px" }} // Set equal height and adjust line-height for centering text
        >
          Search
        </button>
      </div>
    </div>

    {/* Reset button */}
    <div>
      <div className="form-group">
        <button 
          type="button"  // Prevent form submit on Reset button click
          className="btn btn-primary" 
          style={{ height: "38px", lineHeight: "20px" }} // Set equal height and adjust line-height for centering text
          onClick={handleReset}
        >
          Reset
        </button>
      </div>
    </div>

  </div>
</form>

  </div>
</div>




              <div className="card-body" style={{ marginLeft: "-19px" }}>
                {loading ? (
                  <Loader /> 
                ) : (
                  <>
                    <div className="table-responsive">
                      
                    <table className="display dataTable" id="advance-1">
  <thead>
    <tr>
      <th>Sr. No</th>
      <th>Connector Name</th>
      <th>Connector ID</th>
      <th>Charger Name</th>
      <th>Station Name</th>
      <th>IMEI Number</th>
      <th>Status</th>
      <th>Created Date</th>
  
    </tr>
  </thead>
  <tbody>
    {filteredConnectorsData?.length === 0 ? (
      <tr>
        <td colSpan="8" className="text-center">No Data Available</td>
      </tr>
    ) : (
      filteredConnectorsData?.map((connector, index) => (
        <tr key={index}>
          <td style={{ whiteSpace: 'nowrap' }}>{(page - 1) * Limit + index + 1}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{connector?.connector_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{connector?.connectorId}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{connector?.charger_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{connector?.station_name}</td>
          <td style={{ whiteSpace: 'nowrap' }}>{connector?.imei_number}</td>
          <td>
            <button
  className="btn"
  style={{
    backgroundColor: getStatusColors(connector.connector_status),  // Background color based on status
    color: 'Black',                           // Ensure the text is readable on all backgrounds
    border: 'none',                           // Optional: removes border for a cleaner look
    width: '100px',                           // Fixed width
    height: '40px',                           // Fixed height
    padding: '0',                             // Ensure no extra padding affects size
    lineHeight: '40px',                       // Center text vertically
    textAlign: 'center'                       // Center text horizontally
  }}
>
  {connector.connector_status}
</button>

</td>
          <td style={{ whiteSpace: 'nowrap' }}>{connector?.createdAt}</td>
         
         


    
        </tr>
      ))
    )}
  </tbody>
</table>

                    </div>

                    <div className="pagination-container mt-4">
                      <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        forcePage={page - 1} 
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Connectors;
